/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_BulkInputs */

const en_portal_goal_bulk = /** @type {(inputs: Portal_Goal_BulkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bulk`)
};

const pl_portal_goal_bulk = /** @type {(inputs: Portal_Goal_BulkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masa`)
};

/**
* | output |
* | --- |
* | "Bulk" |
*
* @param {Portal_Goal_BulkInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_bulk = /** @type {((inputs?: Portal_Goal_BulkInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_BulkInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_bulk(inputs)
	return en_portal_goal_bulk(inputs)
});